<template>
  <div class="layout_header">
    <div class="row_top">
      <div>
        <img
          @click="toggleCollapse"
          v-if="isCollapse"
          src="@/assets/img/expand.png"
          alt=""
        />
        <img
          @click="toggleCollapse"
          v-else
          src="@/assets/img/fold.png"
          alt=""
        />
        <div @click="toHome">{{ appTitle }}</div>
      </div>
      <div>
        <el-dropdown trigger="click">
          <div class="el-dropdown-link">
            <div>
              {{ userInfo.username }}
            </div>
            <img src="@/assets/img/xl_info.png" alt="" />
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="showInfo = true"
                >个人信息</el-dropdown-item
              >
              <el-dropdown-item @click="toLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row_bottom">
      <div
        class="scroll-arrow left-arrow"
        @click="scrollLeft"
        v-if="showLeftArrow"
      >
        <img src="@/assets/img/left-arrow.png" alt="左滚动" />
      </div>
      <div class="he_tabs" ref="scrollWrapper" @wheel="handleWheel">
        <div
          v-for="item in tabsArr"
          :key="item.url"
          :class="{ active: isActive(item.url) }"
          :ref="
            (el) => {
              if (isActive(item.url)) activeTabRef = el;
            }
          "
          @contextmenu.prevent="openMenu($event, item)"
        >
          <div @click="handleToUrl(item)">{{ item.name }}</div>
          <div class="close_icon" @click.stop="handleClose(item)">
            <img src="@/assets/img/close_tab.png" alt="" />
          </div>
        </div>
      </div>
      <div
        class="scroll-arrow right-arrow"
        @click="scrollRight"
        v-if="showRightArrow"
      >
        <img src="@/assets/img/right-arrow.png" alt="右滚动" />
      </div>
    </div>
    <div class="info_card" v-if="showInfo">
      <div class="box" v-if="cardType == 1">
        <div class="box_title">个人信息</div>
        <div class="box_content">
          <div class="info_item">
            <el-tag class="set_tag" type="primary" size="large">用户名</el-tag
            >{{ userInfo.username ? userInfo.username : "--" }}
          </div>
          <div class="info_item">
            <el-tag class="set_tag" type="primary" size="large">姓名</el-tag
            >{{ userInfo.realName ? userInfo.realName : "--" }}
          </div>
          <div class="info_item">
            <el-tag class="set_tag" type="primary" size="large">编码</el-tag
            >{{ userInfo.customCode ? userInfo.customCode : "--" }}
          </div>
          <div class="info_item">
            <el-tag class="set_tag" type="primary" size="large">手机号</el-tag
            >{{ userInfo.mobileNum ? userInfo.mobileNum : "--" }}
          </div>
          <div class="info_item">
            <el-tag class="set_tag" type="primary" size="large">角色</el-tag
            >{{ userInfo.roleName ? userInfo.roleName : "--" }}
          </div>
          <div class="info_item">
            <el-button type="info" @click="updatePhone" plain
              >修改手机号</el-button
            >
            <el-button type="info" @click="updatePassword" plain
              >修改密码</el-button
            >
          </div>
        </div>
        <div class="box_btn" @click="showInfo = false">关 闭</div>
      </div>
      <div class="box" v-else-if="cardType == 2">
        <div class="box_title">修改密码</div>
        <div class="box_content box_content1">
          <el-form
            ref="passwordFormRef"
            :model="passwordForm"
            :rules="passwordRules"
            label-width="auto"
            style="width: 70%; margin: auto"
          >
            <el-form-item label="原密码" prop="currentPass">
              <el-input
                placeholder="请输入原密码"
                v-model="passwordForm.currentPass"
                clearable
                type="password"
                show-password
              />
            </el-form-item>
            <el-form-item label="新密码" prop="newPass">
              <el-input
                placeholder="请输入新密码"
                v-model="passwordForm.newPass"
                clearable
                type="password"
                show-password
              />
            </el-form-item>
            <el-form-item label="确认密码" prop="newPassRepeat">
              <el-input
                placeholder="请确认密码"
                v-model="passwordForm.newPassRepeat"
                clearable
                type="password"
                show-password
              />
            </el-form-item>
            <el-form-item>
              <el-button type="info" size="large" @click="backInfo"
                >返 回</el-button
              >
              <el-button type="warning" size="large" @click="handlePassword"
                >修 改</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="box" v-else>
        <div class="box_title">修改手机号</div>
        <div class="box_content box_content1">
          <el-form
            ref="phoneFormRef"
            :model="phoneForm"
            :rules="phoneRules"
            label-width="auto"
            style="width: 70%; margin: auto"
          >
            <el-form-item label="手机号" prop="mobileNum">
              <el-input
                placeholder="请输入手机号"
                v-model="phoneForm.mobileNum"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="info" size="large" @click="backInfo"
                >返 回</el-button
              >
              <el-button type="warning" size="large" @click="handlePhone"
                >修 改</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div
      class="context_menu"
      v-if="showMenu"
      :style="{ top: menuY + 'px', left: menuX + 'px' }"
    >
      <div @click="handleCloseOther">关闭其他选项卡</div>
      <div @click="handleCloseLeft">关闭左侧选项卡</div>
      <div @click="handleCloseRight">关闭右侧选项卡</div>
      <div @click="handleCloseAll">关闭所有选项卡</div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted, computed, watch, nextTick } from "vue";
import {
  validatePassRepeat,
  validatePass,
  validatePhone,
  setStorage,
  getStorage,
  removeStorage,
} from "@/utils";
import { updateMyPhone, updateMyPwd } from "@/api/index";
import { ArrowDown } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
const props = defineProps(["isCollapse"]);
const emit = defineEmits(["toggleCollapse"]);

const showMenu = ref(false);
const menuX = ref(0);
const menuY = ref(0);
const scrollWrapper = ref(null);
const activeTabRef = ref(null);
// const tabsArr = ref([
//   { name: "云柜列表", url: "/deviceList" },
//   { name: "物品列表", url: "/goodList" },
//   { name: "云柜用户", url: "/userList" },
// ]);
const tabsArr = ref(getStorage("MENU_TABS"));
const store = useStore();
let router = useRouter(); //路由
const route = useRoute();
const showInfo = ref(false); // 显示个人信息弹框
const appTitle = ref(getStorage("APP_TITLE")); //管理系统标题
const cardType = ref(1); // 1:个人信息 2:修改密码 3:修改手机号
const phoneFormRef = ref(null); // 手机号表单
const phoneForm = ref({}); // 手机号表单数据
const phoneRules = ref({
  mobileNum: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    { validator: validatePhone, trigger: "blur" },
  ],
}); //手机号表单校验规则
const passwordFormRef = ref(null); // 密码表单
const passwordForm = ref({}); // 密码表单数据
const passwordRules = ref({
  currentPass: [{ required: true, message: "请输入原密码", trigger: "blur" }],
  newPass: [
    { required: true, message: "请输入新密码", trigger: "blur" },
    { validator: validatePass, trigger: "blur" },
  ],
  newPassRepeat: [
    { required: true, message: "请确认密码", trigger: "blur" },
    {
      validator: (rule, value, callback) =>
        validatePassRepeat(rule, value, callback, passwordForm.value.newPass),
      trigger: "blur",
    },
  ],
}); // 密码表单校验规则
const userInfo = ref(getStorage("webUserVo")); //用户信息
console.log(userInfo.value, "------用户信息------");
let nowTimer = null;
const showLeftArrow = ref(false);
const showRightArrow = ref(false);
const contextMenuItem = ref(null);
// 监听路由变化，自动滚动到当前标签
watch(
  () => route.path,
  (newPath) => {
    nextTick(() => {
      scrollToActiveTab();
      checkScrollButtons();
      setTimeout(() => {
        scrollToActiveTab();
      }, 1000);
    });
  },
  { immediate: true }
);
// 监听选项卡数组变化
watch(
  () => tabsArr.value,
  () => {
    nextTick(() => {
      checkScrollButtons();
    });
  },
  { deep: true }
);

onMounted(() => {
  nowTimer = setInterval(() => {
    tabsArr.value = getStorage("MENU_TABS") ? getStorage("MENU_TABS") : [];
  }, 1000);
  window.addEventListener("resize", checkScrollButtons);
});
onUnmounted(() => {
  // 清除定时器
  clearInterval(nowTimer);
  nowTimer = null;
  window.removeEventListener("resize", checkScrollButtons);
});
const toggleCollapse = () => {
  console.log("toggleCollapse============");
  emit("toggleCollapse");
};
// 滚动到当前激活的标签页
const scrollToActiveTab = () => {
  if (!scrollWrapper.value || !activeTabRef.value) return;

  const container = scrollWrapper.value;
  const tab = activeTabRef.value;

  const containerRect = container.getBoundingClientRect();
  const tabRect = tab.getBoundingClientRect();
  const containerScrollLeft = container.scrollLeft;

  // 计算相对位置
  const tabLeftRelative =
    tabRect.left - containerRect.left + containerScrollLeft;
  const tabRightRelative =
    tabRect.right - containerRect.left + containerScrollLeft;

  // 添加安全边距
  const SAFETY_MARGIN = 15;

  // 如果标签在可视区域左侧外
  if (tabRect.left < containerRect.left) {
    container.scrollTo({
      left: tabLeftRelative - SAFETY_MARGIN,
      behavior: "smooth",
    });
  }
  // 如果标签在可视区域右侧外
  else if (tabRect.right > containerRect.right) {
    const scrollTo = tabRightRelative - containerRect.width + SAFETY_MARGIN;
    container.scrollTo({
      left: scrollTo,
      behavior: "smooth",
    });
  }
  // 如果标签比容器还宽（极端情况）
  else if (tabRect.width > containerRect.width) {
    container.scrollTo({
      left: tabLeftRelative - SAFETY_MARGIN,
      behavior: "smooth",
    });
  }
  setTimeout(checkScrollButtons, 100);
};
// const scrollToActiveTab = () => {
//   if (!scrollWrapper.value || !activeTabRef.value) return

//   const container = scrollWrapper.value
//   const tab = activeTabRef.value

//   const containerWidth = container.offsetWidth
//   const tabOffsetLeft = tab.offsetLeft
//   const tabWidth = tab.offsetWidth
//   const currentScroll = container.scrollLeft

//   // 计算标签页右侧边界位置
//   const tabRightEdge = tabOffsetLeft + tabWidth
//   // 计算容器右侧边界位置
//   const containerRightEdge = currentScroll + containerWidth

//   // 如果标签页左侧不在可视区域内
//   if (tabOffsetLeft < currentScroll) {
//     container.scrollTo({
//       left: tabOffsetLeft - 200, // 向左多滚动10px留出边距
//       behavior: 'smooth'
//     })
//   }
//   // 如果标签页右侧不在可视区域内
//   else if (tabRightEdge > containerRightEdge) {
//     // 计算需要滚动的距离，确保标签页右侧完整显示
//     const scrollTo = tabRightEdge - containerWidth + 10 // 向右多滚动10px留出边距
//     container.scrollTo({
//       left: scrollTo,
//       behavior: 'smooth'
//     })
//   }
//   // 如果标签页宽度大于容器宽度（极端情况）
//   else if (tabWidth > containerWidth) {
//     container.scrollTo({
//       left: tabOffsetLeft - 10,
//       behavior: 'smooth'
//     })
//   }
// }
// 检查是否需要显示滚动箭头
const checkScrollButtons = () => {
  if (!scrollWrapper.value) return;

  const { scrollWidth, clientWidth, scrollLeft } = scrollWrapper.value;

  showLeftArrow.value = scrollLeft > 0;
  showRightArrow.value = scrollLeft < scrollWidth - clientWidth;
};

// 向左滚动
const scrollLeft = () => {
  if (!scrollWrapper.value) return;
  scrollWrapper.value.scrollBy({ left: -200, behavior: "smooth" });
};

// 向右滚动
const scrollRight = () => {
  if (!scrollWrapper.value) return;
  scrollWrapper.value.scrollBy({ left: 200, behavior: "smooth" });
};
const updatePassword = () => {
  cardType.value = 2;
};
const handlePassword = () => {
  passwordFormRef.value.validate((valid) => {
    if (valid) {
      updateMyPwd(passwordForm.value)
        .then((res) => {
          ElMessage({
            message: `修改密码成功,请重新登录`,
            type: "success",
          });
          toLogout();
        })
        .catch((err) => {
          ElMessage({
            message: err,
            type: "error",
          });
        });
    }
  });
};
// 修改手机号
const updatePhone = () => {
  cardType.value = 3;
};
const handlePhone = () => {
  phoneFormRef.value.validate((valid) => {
    if (valid) {
      phoneForm.value.id = userInfo.value.id;
      updateMyPhone(phoneForm.value)
        .then((res) => {
          ElMessage({
            message: `修改手机号成功`,
            type: "success",
            customClass: "high-z-index-message",
          });
          backInfo();
        })
        .catch((err) => {
          ElMessage({
            message: err,
            type: "error",
          });
        });
    }
  });
};
// 返回个人信息页
const backInfo = () => {
  if (cardType.value == 2) {
    console.log(passwordForm.value, "------密码表单重置------");
    passwordFormRef.value.resetFields();
    passwordForm.value = {};
  } else if (cardType.value == 3) {
    console.log(phoneForm.value, "------手机号表单重置------");
    phoneFormRef.value.resetFields();
    phoneForm.value = {};
  }
  cardType.value = 1;
};
// 退出登录
const toLogout = () => {
  store
    .dispatch("handleLogOut")
    .then(() => {
      ElMessage({
        message: "退出登录成功",
        type: "success",
      });
      router.push("/");
    })
    .catch((err) => {
      ElMessage.error(err);
    });
};
const toHome = () => {
  // router.push("/home");
};
// 处理鼠标滚轮事件 - 实现横向滚动
const handleWheel = (e) => {
  if (!scrollWrapper.value) return;
  // 阻止默认的垂直滚动行为
  e.preventDefault();
  // 使用 deltaY 值进行横向滚动
  scrollWrapper.value.scrollLeft += e.deltaY;
  // 也可以使用 deltaX 如果设备支持
  // scrollWrapper.value.scrollLeft += e.deltaX || e.deltaY
};
// 检查当前是否是激活的 Tab
const isActive = (url) => {
  return route.path === url;
};
const handleToUrl = (data) => {
  router.push(data.url);
};
// 关闭 Tab
const handleClose = (item) => {
  const pathUrl = route.path;
  const index = tabsArr.value.findIndex((tab) => tab.url === item.url);
  if (index !== -1) {
    tabsArr.value.splice(index, 1);
    // 如果关闭的是当前激活的 Tab，则跳转到最后一个 Tab
    if (isActive(item.url)) {
      console.log("关闭的是当前激活的 Tab");
      const lastTab = tabsArr.value[tabsArr.value.length - 1];
      setTimeout(() => {
        if (lastTab) {
          router.push(lastTab.url);
          console.log("关闭的是当前激活的 Tab1");
        } else {
          // 如果没有 Tab 了，跳转到首页或其他默认页面
          router.push("/layout");
          console.log("关闭的是当前激活的 Tab2");
        }
      }, 200);
    }
    // else {
    //   setTimeout(() => {
    //     router.push(pathUrl);
    //     console.log("关闭的不是当前激活的 Tab");
    //   }, 200);
    // }
  }
  setStorage("MENU_TABS", tabsArr.value);
};
const openMenu = (e, item) => {
  console.log("openMenu", e, item);
  showMenu.value = true;
  menuX.value = e.pageX - 100;
  menuY.value = e.pageY + 20;
  contextMenuItem.value = item; // 存储当前右键点击的选项卡
};
// 关闭所有选项卡
const handleCloseAll = () => {
  tabsArr.value = [];
  setStorage("MENU_TABS", []);
  // tabsArr.value = [{ name: "设备列表", url: "/deviceList" }];
  // setStorage("MENU_TABS", [{ name: "设备列表", url: "/deviceList" }]);
  router.push("/layout"); // 跳转到默认页面
  showMenu.value = false;
};
// 关闭其他选项卡
const handleCloseOther = () => {
  if (!contextMenuItem.value) return;

  // 保留当前右键点击的选项卡
  tabsArr.value = [contextMenuItem.value];
  setStorage("MENU_TABS", tabsArr.value);

  // 如果当前激活的不是保留的选项卡，则跳转到保留的选项卡
  if (!isActive(contextMenuItem.value.url)) {
    router.push(contextMenuItem.value.url);
  }

  showMenu.value = false;
};
// 关闭左侧选项卡
const handleCloseLeft = () => {
  if (!contextMenuItem.value) return;

  const currentIndex = tabsArr.value.findIndex(
    (tab) => tab.url === contextMenuItem.value.url
  );
  if (currentIndex <= 0) return; // 没有左侧选项卡

  // 删除当前选项卡左侧的所有选项卡
  tabsArr.value.splice(0, currentIndex);
  setStorage("MENU_TABS", tabsArr.value);

  // 如果当前激活的选项卡在删除的范围内，则跳转到当前右键点击的选项卡
  const activeIndex = tabsArr.value.findIndex((tab) => isActive(tab.url));
  if (activeIndex === -1) {
    router.push(contextMenuItem.value.url);
  }

  showMenu.value = false;
};

// 关闭右侧选项卡
const handleCloseRight = () => {
  if (!contextMenuItem.value) return;

  const currentIndex = tabsArr.value.findIndex(
    (tab) => tab.url === contextMenuItem.value.url
  );
  if (currentIndex >= tabsArr.value.length - 1) return; // 没有右侧选项卡

  // 删除当前选项卡右侧的所有选项卡
  tabsArr.value.splice(currentIndex + 1);
  setStorage("MENU_TABS", tabsArr.value);

  // 如果当前激活的选项卡在删除的范围内，则跳转到当前右键点击的选项卡
  const activeIndex = tabsArr.value.findIndex((tab) => isActive(tab.url));
  if (activeIndex === -1) {
    router.push(contextMenuItem.value.url);
  }

  showMenu.value = false;
};
// 点击页面其他区域关闭菜单
const closeMenu = (e) => {
  if (showMenu.value) {
    showMenu.value = false;
  }
};

// 监听点击事件
document.addEventListener("click", closeMenu);
</script>
<style lang="scss" scoped>
.layout_header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  color: #2d8cf0;
  cursor: pointer;
  > div {
    width: 98%;
    margin: auto;
  }
  .row_top {
    height: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
      height: 100%;
      display: flex;
      align-items: center;
    }
    > div:nth-child(1) {
      img {
        width: 22px;
        margin-right: 15px;
      }
      font-size: 21px;
      font-weight: bold;
      letter-spacing: 4px;
    }
  }
  .row_bottom {
    height: 30%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .scroll-arrow {
      width: 24px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f5f7fa;
      cursor: pointer;
      z-index: 10;
      transition: background-color 0.3s;

      &:hover {
        background-color: #e4e7ed;
      }

      img {
        width: 16px;
        height: 16px;
      }
    }
    .left-arrow {
      border-right: 1px solid #dcdfe6;
    }

    .right-arrow {
      border-left: 1px solid #dcdfe6;
    }

    .he_tabs {
      flex: 1;
      height: 100%;
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      position: relative;

      &::-webkit-scrollbar {
        display: none;
      }

      white-space: nowrap;
      > div {
        height: 90%;
        margin-right: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #cecece;
        padding: 0 5px;
        > div {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #424242;
          font-size: 14px;
        }
        .close_icon {
          img {
            width: 18px;
            margin-left: 5px;
          }
        }
      }
      .active {
        background-color: #9eccfa;
        border: 1px solid #409eff;
      }

      // > div {
      //   height: 85%;
      //   padding: 0 20px;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   border: 1px solid #e6e6e6;
      //   margin-right: 5px;
      //   // border-right: 1px solid #e6e6e6;
      //   color: #777777;
      //   > div {
      //     height: 100%;
      //     display: flex;
      //     align-items: center;
      //     justify-content: center;
      //   }
      //   .close_icon {
      //     width: 20%;
      //     font-size: 14px;
      //      padding-left: 10px;
      //     // visibility: hidden;
      //   }
      // }
      // > div:hover {
      //   color: #ff9800;
      //   // border: 1px solid #409eff;

      //   .close_icon {
      //     color: #ff9800;
      //     visibility: visible;
      //     padding-left: 10px;
      //   }
      // }
      // .active {
      //   color: #409eff;
      //   // border: 1px solid #409eff;
      //   .close_icon {
      //     color: #409eff;
      //     visibility: visible;
      //     padding-left: 10px;
      //   }
      // }
    }
  }
  .el-dropdown-link {
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #2d8cf0;
    cursor: pointer;
    img {
      width: 20px;
    }
  }
  .info_card {
    z-index: 999;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    .box {
      width: 700px;
      height: 400px;
      background-color: #fff;
      border-radius: 10px;
      > div {
        width: 95%;
        margin: auto;
      }
      .box_title {
        height: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 20px;
        letter-spacing: 5px;
      }
      .box_content {
        width: 85%;
        height: 72%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        color: #000000;
        .info_item {
          width: 40%;
          margin: 0 10px;
          display: flex;
          align-items: center;

          .set_tag {
            width: 80px;
            margin-right: 20px;
          }
        }
      }
      .box_content1 {
        margin-top: 5%;
        :deep(.el-form-item) {
          margin-bottom: 30px;
        }
        :deep(.el-form-item__content) {
          justify-content: center;
        }
      }
      .box_btn {
        height: 10%;
        width: 150px;
        margin-top: 3%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #2d8cf0;
        color: #fff;
        font-size: 15px;
        border-radius: 10px;
      }
    }
  }
  .high-z-index-message {
    z-index: 9999 !important;
  }
  .context_menu {
    width: auto;
    padding: 0 10px;
    position: fixed;
    background: white;
    // border-radius: 8px;
    border: 1px solid #c8c8c8;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    > div {
      font-size: 14px;
      height: 30px;
      color: #646363;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > div:hover {
      // background-color: rgba($color: #2d8cf0, $alpha: 0.1);
      color: #2d8cf0;
    }
  }
}
</style>